import { Routes } from '@angular/router';
import {GuardService} from "./shared/services/guard.service";
import { environment } from "@environment/environment";

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => environment.captchaDisabled 
      ? import('./components/main/main-no-captcha.component').then(m => m.MainNoCaptchaComponent)
      : import('./components/main/main.component').then(m => m.MainComponent)
  },
  {
    path: 'form',
    loadComponent: () => import('./components/form/form.component').then(m => m.FormComponent),
    canActivate: [GuardService]
  },
  {
    path: 'offers',
    loadComponent: () => import('./components/offers/offers.component').then(m => m.OffersComponent),
    canActivate: []
  },
  {
    path: 'success',
    loadComponent: () => import('./components/success/success.component').then(m => m.SuccessComponent),
    canActivate: [GuardService]
  },
  {
    path: 'data-checking',
    loadComponent: () => import('./components/data-checking/data-checking.component').then(m => m.DataCheckingComponent),
    canActivate: [GuardService]
  },
  {
    path: 'create-policy',
    loadComponent: () => import('./components/create-policy/create-policy.component').then(m => m.CreatePolicyComponent),
    canActivate: [GuardService]
  },
  {
    path: 'prolongation',
    loadComponent: () => import('./components/fast-prolongation/fast-prolongation.component').then(m => m.FastProlongationComponent),
    canActivate: [GuardService]
  },
  {
    path: 'loading',
    loadComponent: () => import('./components/loading-page/loading-page.component').then(m => m.LoadingPageComponent)
  },
  {
    // INS-2364: страница ошибки партнёра Татнефть (WebView уводит сюда при ошибке/истечении сессии)
    path: 'error',
    loadComponent: () => import('./components/error/error.component').then(m => m.ErrorComponent)
  }
];
